const colors = {
  dark: "#231f1f",
  white: "#ffffff",
  grey: "#f5f4f5",
};

export default colors;
